// The raw /api/v2/products/ item, passed through unchanged so the shared
// ProductCardComponent sees mrp, stock flags and shop status.
export interface ProductSearchResult {
  id: number;
  slug: string | null;
  name: string;
  image: string;
  price: string | number;
  final_price: number | string;
  mrp?: number | string;
  discount_value?: number | string | null;
  discount_type?: string | null;
  stock?: number;
  is_in_stock?: boolean;
  unit?: { code?: string };
  shop?: { name?: string; slug?: string; is_accepting_orders?: boolean };
  [key: string]: unknown;
}

export interface ProductSearchPage {
  items: ProductSearchResult[];
  hasMore: boolean;
  count: number;
}

export interface ShopSearchResult {
  id: number;
  slug: string;
  name: string;
  image: string | null;
  rating: number;
  reviewCount?: number;
  isAcceptingOrders: boolean;
  categoryName: string;
  city?: string;
  isServiceProvider?: boolean;
  distanceKm?: number;
}

export interface ServiceSearchResult {
  id: number | string;
  slug: string;
  name: string;
  description: string;
  image: string | null;
  basePrice: number;
  durationMinutes: number;
  rating?: number;
  shopName: string;
  shopSlug: string;
  categoryName: string;
}

export interface CategorySearchResult {
  id: number;
  slug: string;
  name: string;
  image: string | null;
  categoryType: string;
}

export interface SearchResults {
  query: string;
  products: ProductSearchResult[];
  productsHasMore: boolean;
  /** Total matching products reported by the API (0 when unknown). */
  productsCount: number;
  shops: ShopSearchResult[];
  services: ServiceSearchResult[];
  categories: CategorySearchResult[];
}

export type SearchResultTab = 'all' | 'products' | 'shops' | 'services' | 'categories';

export interface RecentSearchEntry {
  query: string;
  timestamp: number;
}

export function emptySearchResults(query: string = ''): SearchResults {
  return { query, products: [], productsHasMore: false, productsCount: 0, shops: [], services: [], categories: [] };
}

export function totalResultCount(results: SearchResults): number {
  return Math.max(results.products.length, results.productsCount) + results.shops.length + results.services.length + results.categories.length;
}
